import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary, FallbackProps } from 'react-error-boundary';

import config from 'config';
import { settings, user } from 'core';

import type { RouteComponentProps } from 'ui/utilities';
import { ErrorGeneric } from 'ui/components';
import { Switch, Route, Redirect } from 'ui/utilities';
import { pagesMapper } from 'ui/pages';

const Routes = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  const {
    data: { routes },
  } = settings.hooks.useSettings();

  const ErrorFallback = ({ error }: FallbackProps) => {
    useEffect(() => {
      dataLayer.push({
        'event-action': `callback:${location.pathname}`,
        'event-category': `${config.app.short}-portal:${location.pathname}`,
        'event-label': error,
      });

      window?.newrelic?.noticeError(error, { 'Application Error': error });
    }, []);

    return <ErrorGeneric />;
  };

  const {
    data: { isMultiBrand },
  } = user.hooks.useUser();

  useEffect(() => {
    dispatch({
      type: 'setBreadcrumbs',
      payload: {
        homePage: '',
        currentState: location.state,
        routes,
      },
    });
  }, [location]);

  return (
    <Switch>
      {routes.map((route) => {
        const { component, documentType, ...options } = route;
        const PageComponent = pagesMapper[component];
        const listPageMultibrand = ['page-departments', 'page-categories'];
        const hasMultiBrand = listPageMultibrand?.includes(documentType) && isMultiBrand;
        const document = hasMultiBrand ? `${documentType}-multibrand` : documentType;

        return (
          <Route
            key={options.path}
            exact
            render={(routeProps: RouteComponentProps) => (
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <PageComponent documentType={document} {...routeProps} />
              </ErrorBoundary>
            )}
            {...options}
          />
        );
      })}

      <Redirect to="/" />
    </Switch>
  );
};

export default Routes;
